import React from 'react';
import {theme} from '../constants';

const technologies = [
  'PWA Ready',
  '30 + screens',
  'Easy to Edit',
  'Free Updates',
];

const technologies2 = [
  'Reusable Components',
  'User Friendly Design',
  'Good color combination',
  'Fast Performance',
];

export const Features: React.FC = () => {
  return (
    <div
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        display: 'flex',
        marginBottom: 20,
      }}
    >
      <ul
        style={{
          listStyleType: 'none',
          padding: 0,
          marginRight: 50,
        }}
      >
        {technologies.map((tech) => (
          <li
            key={tech}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: 10,
            }}
          >
            <div
              style={{
                width: 6,
                height: 6,
                backgroundColor: '#193364',
                borderRadius: 10,
                marginRight: 10,
              }}
            ></div>
            <div
              style={{
                color: '#60708E',
                ...theme.fonts.Mulish_400Regular,
              }}
            >
              {tech}
            </div>
          </li>
        ))}
      </ul>
      <ul
        style={{
          listStyleType: 'none',
          padding: 0,
        }}
      >
        {technologies2.map((tech) => (
          <li
            key={tech}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: 10,
            }}
          >
            <div
              style={{
                width: 6,
                height: 6,
                backgroundColor: '#193364',
                borderRadius: 10,
                marginRight: 10,
              }}
            ></div>
            <div
              style={{
                color: '#60708E',
                ...theme.fonts.Mulish_400Regular,
              }}
            >
              {tech}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
